module.exports = __webpack_public_path__ + "images/style_setting.svg";